import base from './base'
// import { getDeviceType } from './http'

// const baseURL = process.env.VUE_APP_API_BASE_URL || '/api'

export default {
  getModuleDetail(params) {
    return base.get('/ai/doctor/detail', params)
  },

  checkRecentRecord(params) {
    return base.get('/health/blood_pressure/checkRecentRecord', params)
  },

  bloodClockIn(data) {
    return base.post('/health/blood_pressure/clockIn', data)
  },

  chat(data) {
    return base.post('/ai/ecust/chat', data)
  }
}
